import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_tags_ddService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { entityTypeId?: number, fullTextSearch?: string, groupIds?: number[], tagIds?: number[] }): 
  Promise<{ result: { Id?: number, Name?: string, TagsGroupLookups?: { TagId?: number, TagGroupId?: number, TagGroup?: { Name?: string } }[], EntityTypes?: { EntityTypeId?: number }[] }[] }> 
  {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_tags_dd/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { entityTypeId?: number, fullTextSearch?: string, groupIds?: number[], tagIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Name?: string, TagsGroupLookups?: { TagId?: number, TagGroupId?: number, TagGroup?: { Name?: string } }[], EntityTypes?: { EntityTypeId?: number }[] }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_tags_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { entityTypeId?: number, fullTextSearch?: string, groupIds?: number[], tagIds?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, Name?: string, TagsGroupLookups?: { TagId?: number, TagGroupId?: number, TagGroup?: { Name?: string } }[], EntityTypes?: { EntityTypeId?: number }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_tags_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      entityTypeId?: number, fullTextSearch?: string, groupIds?: number[], tagIds?: number[]    }) {
      return false;
    }
}
